import { Component, inject, OnInit, signal } from '@angular/core';
import { CardComponent } from '../../../components/card/card.component';
import { firstValueFrom } from 'rxjs';
import { GraphComponent, lineGraphStyle } from '../../../components/graph/graph.component';
import { ChartData, ChartOptions } from 'chart.js';
import { MetricCardData, MetricCardComponent } from '../../../components/metric-card/metric-card.component';
import { BackendService } from '../../../api/bff/backend.service';
import { fillMissingDates } from '../../../utils/date/date';

@Component({
  selector: 'app-service-metrics',
  imports: [CardComponent, GraphComponent, MetricCardComponent],
  templateUrl: './service-metrics.component.html',
  styleUrl: './service-metrics.component.css',
})
export class ServiceMetricsComponent implements OnInit {
  private backend = inject(BackendService);
  protected graph = signal<
    { data: ChartData<'line', { x: string; y: number }[]>; options: ChartOptions<'line'> } | undefined
  >(undefined);
  protected services = signal<(MetricCardData & { id: string })[] | undefined>(undefined);

  ngOnInit() {
    firstValueFrom(this.backend.getTelemetryOverview()).then((data) => {
      this.services.set(
        data.services.map((service) => ({
          id: service.id,
          title: service.name,
          subtitle: service.description,
          count: service.count,
          countTitle: $localize`Service calls`,
          link: service.id,
          linkLabel: $localize`See metrics`,
        })),
      );
      const chartData = Object.entries(data.graph).map(([date, value]) => ({ x: date, y: value as number }));
      const end = new Date(chartData[0]?.x);
      const start = new Date(chartData[chartData.length - 1]?.x);
      this.graph.set({
        data: {
          datasets: [
            {
              data: fillMissingDates(
                chartData.map((el) => ({ date: el.x, count: el.y })),
                start,
                end,
              ).map((el) => ({ x: el.date, y: el.count })),
              label: $localize`Calls`,
              ...lineGraphStyle,
              fill: false,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'DD.MM',
                },
              },
              ticks: {
                maxRotation: 0,
              },
            },
          },
        },
      });
    });
  }
}
